import { render, staticRenderFns } from "./Gallery22.vue?vue&type=template&id=d2fbfcb6&scoped=true&"
import script from "./Gallery22.vue?vue&type=script&lang=js&"
export * from "./Gallery22.vue?vue&type=script&lang=js&"
import style0 from "./Gallery22.vue?vue&type=style&index=0&id=d2fbfcb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fbfcb6",
  null
  
)

export default component.exports